'use strict';

exports.__esModule = true;
exports.get = get;
exports.create = create;
exports.id = id;
exports.update = update;
exports.remove = remove;
exports.requestCode = requestCode;
exports.verifyCode = verifyCode;
exports.forgottonPassword = forgottonPassword;

var _http = require('../network/http');

var _auth = require('../auth');

var _modelProvider = require('../model-provider');

var _modelProvider2 = _interopRequireDefault(_modelProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  CUSTOMER_USER: '/customer/user',
  CUSTOMER_PASSWORD: '/customer/forgot_password',
  CUSTOMER_REGISTER: '/customer/register',
  VERIFICATION_REQUEST_CODE: '/verification/request_code',
  VERIFICATION_VERIFY_CODE: '/verification/verify_code'
};

var user = {
  get: get,
  create: create,
  login: _auth.login,
  id: id,
  update: update,
  remove: remove,
  requestCode: requestCode,
  verifyCode: verifyCode,
  forgottonPassword: forgottonPassword
};

exports.default = user;

/**
 * Wrapper for `/customer` API endpoint
 */

/**
 * Get a user
 * @returns {User} containing the entity object user
 */

function get(params) {
  return (0, _http.get)(API.CUSTOMER_USER, params).then(_modelProvider2.default.User);
}

/**
 * Create a new user
 * @param {object} user - user object
 * @returns {User} containing the entity object user
 */
function create(userObj) {
  return (0, _http.post)(API.CUSTOMER_REGISTER, userObj).then(_modelProvider2.default.User);
}

/**
 * Get a new user
 * @param {number} userId - users unique id number
 * @returns {User} containing the entity object user
 */
function id(userId) {
  return (0, _http.get)(API.CUSTOMER_USER + '/' + userId).then(_modelProvider2.default.User);
}

/**
 * Update a new user
 * @param {object} user - user object
 * @returns {User} containing the entity object user
 */
function update(userObj) {
  return (0, _http.put)(API.CUSTOMER_USER, userObj).then(_modelProvider2.default.User);
}

/**
 * Delete a new user
 * @param {number} userId - users unique id number
 * @returns {User} containing the entity object user
 */
function remove(userId) {
  return (0, _http.remove)(API.CUSTOMER_USER + '/' + userId).then(_modelProvider2.default.User);
}

/**
 * Request an SMS pin code for mobile validation
 * @returns {promise} containing the entity
 */
function requestCode() {
  return (0, _http.get)(API.VERIFICATION_REQUEST_CODE);
}

/**
 * Verify SMS pin code
 * @param {number} codeObj - 4 digit pin sent via requestCode()
 * @returns {promise} containing the entity object
 */
function verifyCode(codeObj) {
  return (0, _http.post)(API.VERIFICATION_VERIFY_CODE, codeObj);
}

/**
 * Request an email to reset password
 * @param {string} email - users email address associated with account
 * @returns {promise} containing the entity object
 */
function forgottonPassword(email) {
  return (0, _http.post)(API.CUSTOMER_PASSWORD, email);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/user.js
// module id = 1091
// module chunks = 0